<template>
<li>
    <a href="/sharedbookings/1/list/"><i class="fa fa-life-ring"></i> Sharedbookings
        <span class="badge badge-new-bookings" data-toggle="tooltip" data-placement="right" data-html="true" title="Sharedbookings text here">10</span>
    </a>
    <div class="grid-container grid-container3">
        <ul>
            <li><a href="/sharedbookings/1/list/"><i class="fa fa-fw fa-lg fa-list"></i>Buchungen</a></li>
            <li><a href="/sharedbookings/"><i class="fa fa-fw fa-lg fa-calendar"></i>Wochenansicht</a></li>
        </ul>
    </div>
</li>
</template>

<script>
export default {
    //
}
</script>
